import React, { useState, useRef, useEffect } from 'react';
import styles from './styles/otpInput.module.css';

    const OtpInput = ({ length = 6, value = '', onOtpChange }) => {
        const [otp, setOtp] = useState(Array(length).fill(''));
        const inputRefs = useRef([]);

        useEffect(() => {
            if (value === '') {
                setOtp(Array(length).fill(''));
                // opzionale: pulisci anche i DOM input se serve
                inputRefs.current.forEach((el) => { if (el) el.value = ''; });
            }
        }, [value, length]);

    useEffect(() => {
        onOtpChange(otp.join(''));
    }, [otp, onOtpChange]);

    const handleChange = (e, index) => {
        const { value } = e.target;
        if (/^\d$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (index < length - 1) {
                inputRefs.current[index + 1]?.focus();
            }
        } else if (value === '') {
            const newOtp = [...otp];
            newOtp[index] = '';
            setOtp(newOtp);
        }
    };

    const handlePaste = (e, index) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '');
        const newOtp = [...otp];
        for (let i = 0; i < pasted.length && index + i < length; i++) {
            newOtp[index + i] = pasted[i];
        }
        setOtp(newOtp);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
            inputRefs.current[index - 1]?.focus();
        } else if (e.key === 'ArrowLeft' && index > 0) {
            inputRefs.current[index - 1]?.focus();
        } else if (e.key === 'ArrowRight' && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    return (
        <div className={styles.otpContainer}>
            <div className={styles.otpinputs}>
                {otp.map((val, index) => (
                    <input
                        key={index}
                        type="text"
                        maxLength="1"
                        className={styles.otpInput}
                        value={val}
                        ref={el => inputRefs.current[index] = el}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={(e) => handlePaste(e, index)}
                        aria-label={`Codice OTP cifra ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default OtpInput;
